'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChatHeadingConfig = undefined;

var _reselect = require('reselect');

var _getWelcomeMessage = require('../../selectors/widgetDataSelectors/getWelcomeMessage');

var _getChatHeadingConfig = require('conversations-schema/operators/message/getChatHeadingConfig');

var getChatHeadingConfig = exports.getChatHeadingConfig = (0, _reselect.createSelector)(_getWelcomeMessage.getWelcomeMessage, _getChatHeadingConfig.getChatHeadingConfig);